export const GET_ADMIN_ALL_REPORTS = "GET_ADMIN_ALL_REPORTS"